import { createI18n } from 'vue-i18n'
import uz from './locales/uz'
import en from './locales/en'
import ru from './locales/ru'

import elUz from 'element-plus/dist/locale/uz-uz.mjs'
import elEn from 'element-plus/dist/locale/en.mjs'
import elRu from 'element-plus/dist/locale/ru.mjs'

export const elementLocales = {
  uz: elUz,
  en: elEn,
  ru: elRu,
}

const savedLocale = localStorage.getItem('locale') || 'uz'

const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: 'uz',
  messages: { uz, en, ru },
})

export default i18n
